import React from 'react';
import { formatCurrency } from '../../../Utils/Formatters';
import { calculateDiscountPercentage } from '../../../Utils/Helpers';

interface BadgeProductSaleProps {
    product: any;
    outline?: boolean;
    className?: string;
}

const BadgeProductSale = ({
    product,
    outline = false,
    className
}: BadgeProductSaleProps) => {
    if (
        !product ||
        !product.from_price ||
        product.from_price <= 0 ||
        !product.price ||
        product.price <= 0 ||
        (product?.from_price < product?.price)
      ) {
        return null;
      }
    return (
        <div className={`
            ${outline ? 'ring-1 ring-shopfood-success text-shopfood-success' : 'bg-shopfood-success text-white'}
            font-bold px-1.5 py-0.5 text-xs ${className}`
            }>
                -{formatCurrency( calculateDiscountPercentage(product.from_price, product.price), false, false ) }%
        </div>
    );
};

export default BadgeProductSale;
